export const LandingPrivacy = () => {
  return (
    <section className="relative w-full min-h-[700px] py-16 md:py-24 px-6 md:px-12 overflow-hidden bg-gradient-to-br from-[#4A4E69] via-[#4A4E69] to-[#3a3e59]">
      {/* Aqueous Background - Darker for contrast */}
      <div className="absolute inset-0 -z-10"></div>

      {/* Animated Blobs */}
      <div
        className="absolute top-0 left-[10%] w-[600px] h-[600px] rounded-full opacity-15 blur-3xl -z-10"
        style={{
          background: "radial-gradient(circle, rgba(255, 209, 102, 0.6) 0%, rgba(255, 209, 102, 0) 70%)",
          animation: "drift 25s ease-in-out infinite",
        }}
      ></div>
      <div
        className="absolute bottom-0 right-[15%] w-[700px] h-[700px] rounded-full opacity-10 blur-3xl -z-10"
        style={{
          background: "radial-gradient(circle, rgba(216, 222, 233, 0.5) 0%, rgba(216, 222, 233, 0) 70%)",
          animation: "drift 30s ease-in-out infinite reverse",
        }}
      ></div>

      {/* Overlay pattern */}
      <div
        className="absolute inset-0 opacity-[0.02] -z-10"
        style={{
          backgroundImage: "radial-gradient(circle, white 1px, transparent 1px)",
          backgroundSize: "30px 30px",
        }}
      ></div>

      <div
        className="text-center mb-12 md:mb-16"
        style={{
          animation: "fadeInUp 0.8s ease-out",
        }}
      >
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Seu espaço seguro e privado.</h2>
        <p className="text-base md:text-lg text-white/90 leading-relaxed max-w-2xl mx-auto">
          Sua confiança é o pilar da KopfAI.
          <br />
          Nossa política de privacidade é simples: o que é seu, é seu.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 max-w-6xl mx-auto">
        {[
          {
            title: "Nosso Limite Ético",
            content: (
              <>
                Somos uma ferramenta de autoajuda.
                <br />
                Não diagnosticamos, tratamos ou substituímos um profissional de saúde licenciado.
                <br />
                Se você está em crise ou precisa de diagnóstico, procure um psicólogo ou psiquiatra. Em caso de
                emergência, ligue para o CVV (188).
              </>
            ),
          },
          {
            title: "Sua Privacidade é Absoluta",
            content: (
              <>
                Todas as suas conversas são criptografadas.
                <br />
                Nós não venderemos, compartilharemos ou leremos seus dados pessoais e seu histórico de chat.
              </>
            ),
          },
          {
            title: "Você está no Controle",
            content: (
              <>
                Seus dados são usados apenas para salvar seu histórico e permitir que você continue suas conversas.
                <br />
                Você está no controle total e pode excluir seu histórico e sua conta a qualquer momento.
              </>
            ),
          },
        ].map((item, index) => (
          <div
            key={index}
            className="group relative"
            style={{
              animation: `fadeInUp 0.8s ease-out ${0.2 + index * 0.15}s backwards`,
            }}
          >
            {/* Card with glassmorphism */}
            <div className="relative h-full rounded-3xl bg-white/10 backdrop-blur-xl border border-white/20 p-6 md:p-8 transition-all duration-500 hover:bg-white/15 hover:border-[#FFD166]/40 hover:-translate-y-2 hover:shadow-2xl">
              {/* Glow effect on hover */}
              <div
                className="absolute inset-0 rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 -z-10 blur-2xl"
                style={{
                  background: "radial-gradient(circle at 50% 0%, rgba(255, 209, 102, 0.3), transparent 70%)",
                }}
              ></div>

              {/* Top accent line */}
              <div className="absolute top-0 left-8 right-8 h-1 bg-gradient-to-r from-transparent via-[#FFD166] to-transparent opacity-60 rounded-full"></div>

              {/* Icon dot */}
              <div className="flex items-center gap-3 mb-4">
                <div className="w-3 h-3 rounded-full bg-[#FFD166] shadow-lg shadow-[#FFD166]/50 animate-pulse"></div>
                <h3 className="text-xl font-bold text-white">{item.title}</h3>
              </div>

              <p className="text-base md:text-lg text-white/85 leading-relaxed">{item.content}</p>

              {/* Bottom decorative element */}
              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-white/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </div>
          </div>
        ))}
      </div>

      <style>{`
        @keyframes drift {
          0%, 100% { 
            transform: translate(0, 0) scale(1); 
          }
          50% { 
            transform: translate(50px, 50px) scale(1.15); 
          }
        }
        
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(40px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </section>
  );
};
